import uploadMedia from '../../../Services/uploadMedia'

export default (acceptedFiles) => async (dispatch) => {

  dispatch(uploadMedia(acceptedFiles))
  
}
